import styled from "styled-components";
import { AttachIcon } from "../../assets/icons/Icons";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

const StyledLabel = styled.p`
  font-weight: 600;
  color: var(--header-text);
`;

const InputContainer = styled.label`
  cursor: pointer;
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--neutrals-light-gray);
  background-color: #fff;
`;

const InputButton = styled.div`
  cursor: pointer;
  font-weight: 600;
  color: var(--header-text);
`;

const Input = styled.input`
  cursor: pointer;
  display: none;
`;

const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: red;
  height: ${(props) => props.error};
  transition: 300ms;
`;

export const InputFile = ({
  prefix,
  label,
  errorMessage,
  name,
  control,
  placeholder,
  max,
  maxLength,
  idInput,
  onClickInput = null,
  inputProps,
  readOnly = false,
}) => {
  return (
    <Container>
      <StyledLabel>{label}</StyledLabel>
      <div
        onMouseEnter={(e) => {
          onClickInput && onClickInput(idInput);
        }}
      >
        <InputContainer>
          <InputButton>{placeholder}</InputButton>
          <AttachIcon />
        </InputContainer>
        <Input
          readOnly={readOnly}
          type={"file"}
          name="Subir"
          id="upload"
          {...inputProps}
        />
      </div>
      <ErrorMessage>
        {errorMessage === "required" ? "Campo obligatorio" : ""}
      </ErrorMessage>
    </Container>
  );
};
